import styled from '@emotion/styled';

/**
 * Medidas do handoff (Figma "Embed - Handoff Chatbot Compliance na Work+"):
 * card do modal 900x700, raio 16px, borda 1px #eee.
 */
export const CHAT_WIDTH = 900;
export const CHAT_HEIGHT = 700;

export const ChatSlot = styled.div`
  position: relative;
  height: ${CHAT_HEIGHT}px;
  overflow: hidden;
  border-radius: 16px;
`;

/**
 * Nó entregue ao embed.js da BWG. React nunca renderiza filhos aqui de
 * propósito: quem manda no conteúdo é o script externo, que injeta o iframe.
 * Misturar os dois faria o React remover o iframe na próxima reconciliação.
 */
export const EmbedTarget = styled.div`
  width: 100%;
  height: 100%;

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

/** Estados nossos (buscar token, carregar script). O erro do serviço em si
 *  aparece dentro do iframe, desenhado pela BWG. */
export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray9};
  }
`;

export const SidebarButton = styled.div`
  /* o Divider e o botão vivem juntos: se o gating esconder o botão, o divisor
     não pode sobrar solto na sidebar */
  .ant-divider {
    margin: 16px 0;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    gap: 8px;
    border-radius: 8px;

    img {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      object-fit: cover;
    }

    span {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
